import { StatusText } from "@/pages/child-customer/components/status-text";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { ProjectMember } from "../components/project-member";
import { ProjectOperation } from "../components/project-operation";
import { Project } from "../types";
const t = getTranslateNsT("center");

export const getColumns = (isProjectLockedOpen = true) => {
  const columns: ColumnsType<Project.Info> = [
    {
      title: t("user_com_childPro_head_label_name"),
      dataIndex: "projectName",
      width: 100,
    },
    {
      title: t("user_com_childPro_head_label_member"),
      width: 200,
      render: (row) => <ProjectMember {...row} />,
    },
    {
      title: t("user_com_childPro_name_label_params_lock"),
      width: 200,
      render: (row: Project.Info) => (
        <>
          {row.renderNumStatus ? (
            <div>
              {t("user_com_childPro_name_label_params_lock_0") +
                ":" +
                row.renderNum}
            </div>
          ) : (
            ""
          )}
          {row.taskOverTimeStatus ? (
            <div>
              {t("user_com_childPro_name_label_params_lock_1") +
                ":" +
                row.taskOverTime / 3600}
            </div>
          ) : (
            ""
          )}
          {row.munuTaskOverTimeStatus ? (
            <div>
              {t("user_com_childPro_name_label_params_lock_2") +
                ":" +
                row.munuTaskOverTime / 3600}
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      title: t("user_com_childPro_head_label_status"),
      width: 200,
      render: ({ status }) => (
        <StatusText
          status={Number(!status)}
          text={t(`user_com_childPro_head_label_status_${Number(!status)}`)}
        />
      ),
    },
    {
      title: t("user_com_childPro_head_label_create_username"),
      dataIndex: "createUserName",
      width: 200,
    },
    {
      title: t("user_com_childPro_head_label_create_time"),
      width: 200,
      render: (row) => dayjs(row.createTime).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: t("user_com_childPro_head_label_operate"),
      width: 200,
      render: (row) => <ProjectOperation {...row} />,
    },
  ];
  const unlockedColumns = columns.filter((item, index) => index !== 2);
  return isProjectLockedOpen ? columns : unlockedColumns;
};
